export default __webpack_public_path__ + "static/media/xiaochengxu.87b13e97.png";